(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["catalogos-marcas"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sliders = document.querySelectorAll('[data-catalogos-marcas-slider]');

    sliders.forEach((slider) => {
      if (slider.dataset.catalogosMarcasInicializado === 'true') return;
      slider.dataset.catalogosMarcasInicializado = 'true';

      const viewport = slider.querySelector('[data-catalogos-marcas-viewport]');
      const pista = slider.querySelector('[data-catalogos-marcas-pista]');
      const slides = Array.from(slider.querySelectorAll('.seccion-catalogos-marcas__slide'));
      const enlaces = Array.from(slider.querySelectorAll('[data-catalogos-marcas-enlace]'));
      const paginacion = slider.querySelector('[data-catalogos-marcas-paginacion]');

      if (!viewport || !pista || !slides.length || !paginacion) return;

      let paginaActual = 0;
      let paginasTotales = 1;
      let itemsPorVista = 1;
      let inicioX = 0;
      let inicioY = 0;
      let posicionActual = 0;
      let posicionBase = 0;
      let arrastrando = false;
      let gestoHorizontal = false;
      let bloqueoClickHasta = 0;
      let temporizadorAutoplay = null;
      let temporizadorResize = null;
      let rafArrastre = null;

      const autoplayActivo = slider.dataset.autoplay === 'true';
      const intervaloAutoplay = parseInt(slider.dataset.intervalo || 7000, 10);
      const umbralMovimiento = 7;

      enlaces.forEach((enlace) => {
        enlace.setAttribute('draggable', 'false');

        enlace.addEventListener('dragstart', (evento) => {
          evento.preventDefault();
        });

        enlace.addEventListener(
          'click',
          (evento) => {
            if (Date.now() < bloqueoClickHasta) {
              evento.preventDefault();
              evento.stopPropagation();
            }
          },
          true
        );
      });

      slider.querySelectorAll('img, svg').forEach((elemento) => {
        elemento.setAttribute('draggable', 'false');

        elemento.addEventListener('dragstart', (evento) => {
          evento.preventDefault();
        });
      });

      const obtenerPunto = (evento) => {
        const toque = evento.touches && evento.touches.length ? evento.touches[0] : evento.changedTouches && evento.changedTouches.length ? evento.changedTouches[0] : null;

        if (toque) {
          return {
            x: toque.clientX,
            y: toque.clientY
          };
        }

        return {
          x: evento.clientX || 0,
          y: evento.clientY || 0
        };
      };

      const obtenerItemsPorVista = () => {
        if (window.innerWidth >= 990) {
          return parseInt(slider.dataset.columnasDesktop || 3, 10);
        }

        return parseInt(slider.dataset.columnasMovil || 1, 10);
      };

      const obtenerGap = () => {
        const estilos = window.getComputedStyle(pista);
        const gap = parseFloat(estilos.columnGap || estilos.gap || 0);

        return Number.isNaN(gap) ? 0 : gap;
      };

      const obtenerAnchoSlide = () => {
        const primerSlide = slides[0];

        if (!primerSlide) return 0;

        return primerSlide.getBoundingClientRect().width + obtenerGap();
      };

      const obtenerMaxPagina = () => {
        return Math.max(0, Math.ceil(slides.length / itemsPorVista) - 1);
      };

      const obtenerPosicionPagina = () => {
        return -(paginaActual * itemsPorVista * obtenerAnchoSlide());
      };

      const aplicarTransform = (valor) => {
        posicionActual = valor;
        pista.style.setProperty('transform', 'translate3d(' + valor + 'px, 0, 0)', 'important');
      };

      const aplicarTransformSuave = () => {
        aplicarTransform(obtenerPosicionPagina());
      };

      const actualizarPuntosActivos = () => {
        const puntos = paginacion.querySelectorAll('.seccion-catalogos-marcas__punto');

        puntos.forEach((punto, indice) => {
          punto.classList.toggle('is-activo', indice === paginaActual);
        });
      };

      const irAPagina = (indice) => {
        paginaActual = Math.max(0, Math.min(indice, obtenerMaxPagina()));
        aplicarTransformSuave();
        actualizarPuntosActivos();
      };

      const crearPaginacion = () => {
        paginacion.innerHTML = '';

        for (let i = 0; i < paginasTotales; i++) {
          const punto = document.createElement('button');
          punto.type = 'button';
          punto.className = 'seccion-catalogos-marcas__punto';
          punto.setAttribute('aria-label', 'Ir a la página ' + (i + 1));

          if (i === paginaActual) {
            punto.classList.add('is-activo');
          }

          punto.addEventListener('click', () => {
            irAPagina(i);
            reiniciarAutoplay();
          });

          paginacion.appendChild(punto);
        }
      };

      const actualizarSlider = () => {
        itemsPorVista = obtenerItemsPorVista();
        paginasTotales = Math.max(1, Math.ceil(slides.length / itemsPorVista));

        if (paginaActual > paginasTotales - 1) {
          paginaActual = paginasTotales - 1;
        }

        crearPaginacion();
        aplicarTransformSuave();
        actualizarPuntosActivos();

        paginacion.style.display = paginasTotales <= 1 ? 'none' : 'flex';
      };

      const irSiguiente = () => {
        if (paginasTotales <= 1) return;

        if (paginaActual >= paginasTotales - 1) {
          irAPagina(0);
        } else {
          irAPagina(paginaActual + 1);
        }
      };

      const irAnterior = () => {
        if (paginasTotales <= 1) return;

        if (paginaActual <= 0) {
          irAPagina(paginasTotales - 1);
        } else {
          irAPagina(paginaActual - 1);
        }
      };

      const detenerAutoplay = () => {
        if (temporizadorAutoplay) {
          clearInterval(temporizadorAutoplay);
          temporizadorAutoplay = null;
        }
      };

      const iniciarAutoplay = () => {
        if (!autoplayActivo || paginasTotales <= 1) return;

        detenerAutoplay();

        temporizadorAutoplay = setInterval(() => {
          irSiguiente();
        }, intervaloAutoplay);
      };

      const reiniciarAutoplay = () => {
        detenerAutoplay();
        iniciarAutoplay();
      };

      const bloquearClickTemporalmente = () => {
        bloqueoClickHasta = Date.now() + 280;
      };

      const iniciarArrastre = (evento) => {
        if (paginasTotales <= 1) return;

        if (evento.type === 'mousedown' && evento.button !== 0) return;

        const punto = obtenerPunto(evento);

        arrastrando = true;
        gestoHorizontal = false;
        inicioX = punto.x;
        inicioY = punto.y;
        posicionBase = obtenerPosicionPagina();

        detenerAutoplay();
      };

      const moverArrastre = (evento) => {
        if (!arrastrando) return;

        const punto = obtenerPunto(evento);
        const diferenciaX = punto.x - inicioX;
        const diferenciaY = punto.y - inicioY;
        const absX = Math.abs(diferenciaX);
        const absY = Math.abs(diferenciaY);

        if (!gestoHorizontal && absX > umbralMovimiento && absX > absY * 1.15) {
          gestoHorizontal = true;
          pista.classList.add('is-arrastrando');
          viewport.classList.add('is-arrastrando');
        }

        if (!gestoHorizontal) return;

        if (evento.cancelable) {
          evento.preventDefault();
        }

        if (rafArrastre) {
          window.cancelAnimationFrame(rafArrastre);
        }

        rafArrastre = window.requestAnimationFrame(() => {
          aplicarTransform(posicionBase + diferenciaX);
          rafArrastre = null;
        });
      };

      const terminarArrastre = (evento) => {
        if (!arrastrando) return;

        const punto = obtenerPunto(evento);
        const diferenciaX = punto.x - inicioX;
        const diferenciaY = punto.y - inicioY;
        const absX = Math.abs(diferenciaX);
        const absY = Math.abs(diferenciaY);
        const huboMovimiento = Math.max(absX, absY) > umbralMovimiento;
        const limiteCambio = Math.max(38, obtenerAnchoSlide() * 0.14);

        arrastrando = false;
        pista.classList.remove('is-arrastrando');
        viewport.classList.remove('is-arrastrando');

        if (rafArrastre) {
          window.cancelAnimationFrame(rafArrastre);
          rafArrastre = null;
        }

        if (gestoHorizontal) {
          bloquearClickTemporalmente();

          if (diferenciaX <= -limiteCambio) {
            irSiguiente();
          } else if (diferenciaX >= limiteCambio) {
            irAnterior();
          } else {
            irAPagina(paginaActual);
          }
        } else {
          if (huboMovimiento) {
            bloquearClickTemporalmente();
          }

          irAPagina(paginaActual);
        }

        gestoHorizontal = false;
        reiniciarAutoplay();
      };

      viewport.addEventListener('touchstart', iniciarArrastre, { passive: true });
      viewport.addEventListener('touchmove', moverArrastre, { passive: false });
      viewport.addEventListener('touchend', terminarArrastre, { passive: true });
      viewport.addEventListener('touchcancel', terminarArrastre, { passive: true });

      viewport.addEventListener('mousedown', iniciarArrastre);
      viewport.addEventListener('mousemove', moverArrastre);
      window.addEventListener('mouseup', terminarArrastre);

      viewport.addEventListener('mouseleave', () => {
        if (!arrastrando) return;

        arrastrando = false;
        gestoHorizontal = false;
        pista.classList.remove('is-arrastrando');
        viewport.classList.remove('is-arrastrando');
        irAPagina(paginaActual);
        reiniciarAutoplay();
      });

      viewport.addEventListener('dragstart', (evento) => {
        evento.preventDefault();
      });

      slider.addEventListener('mouseenter', detenerAutoplay);
      slider.addEventListener('mouseleave', iniciarAutoplay);

      window.addEventListener('resize', () => {
        clearTimeout(temporizadorResize);

        temporizadorResize = setTimeout(() => {
          actualizarSlider();
          reiniciarAutoplay();
        }, 120);
      });

      actualizarSlider();
      iniciarAutoplay();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["coleccion-destacada-kylie"] && !Shopify.designMode) return;
  try {
    
(function () {
  function obtenerRootShopify() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }

    return '/';
  }

  function obtenerCarritoVisual() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  function abrirCarritoVisual() {
    var carritoVisual = obtenerCarritoVisual();

    if (carritoVisual && typeof carritoVisual.open === 'function') {
      carritoVisual.open();
      return;
    }

    var botonCarrito = document.querySelector('#cart-icon-bubble') || document.querySelector('.header__icon--cart') || document.querySelector('a[href="/cart"]');

    if (botonCarrito) {
      botonCarrito.click();
    }
  }

  function reemplazarDrawerCarrito(htmlDrawer) {
    if (!htmlDrawer) {
      return false;
    }

    var documento = new DOMParser().parseFromString(htmlDrawer, 'text/html');
    var nuevoDrawer = documento.querySelector('cart-drawer');
    var drawerActual = document.querySelector('cart-drawer');

    if (!nuevoDrawer || !drawerActual) {
      return false;
    }

    drawerActual.outerHTML = nuevoDrawer.outerHTML;

    return true;
  }

  function refrescarDrawerCarrito(respuestaCarrito) {
    if (respuestaCarrito && respuestaCarrito.sections && respuestaCarrito.sections['cart-drawer']) {
      var reemplazadoDesdeRespuesta = reemplazarDrawerCarrito(respuestaCarrito.sections['cart-drawer']);

      if (reemplazadoDesdeRespuesta) {
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: respuestaCarrito }));
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: respuestaCarrito }));

        window.requestAnimationFrame(function () {
          abrirCarritoVisual();
        });

        return Promise.resolve();
      }
    }

    return fetch(obtenerRootShopify() + '?sections=cart-drawer', {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then(function (respuesta) {
        return respuesta.json();
      })
      .then(function (secciones) {
        reemplazarDrawerCarrito(secciones['cart-drawer']);

        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: respuestaCarrito }));
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: respuestaCarrito }));

        window.requestAnimationFrame(function () {
          abrirCarritoVisual();
        });
      });
  }

  function obtenerDatosProductoDesdeBoton(boton) {
    var tarjeta = boton.closest('article') || boton.closest('[class*="__tarjeta"]') || boton.closest('li');
    var form = boton.closest('form');

    if (!form && tarjeta) {
      form = tarjeta.querySelector('form[action*="/cart/add"]') || tarjeta.querySelector('form[action*="/cart/add.js"]') || tarjeta.querySelector('form');
    }

    var inputId = form ? form.querySelector('input[name="id"]') : null;

    if (!inputId && tarjeta) {
      inputId = tarjeta.querySelector('input[name="id"]');
    }

    var inputCantidad = tarjeta ? tarjeta.querySelector('input[name="quantity"]') : null;

    var variantId = inputId ? inputId.value : '';
    var quantity = inputCantidad ? parseInt(inputCantidad.value, 10) : 1;

    if (Number.isNaN(quantity) || quantity < 1) {
      quantity = 1;
    }

    return {
      variantId: variantId,
      quantity: quantity
    };
  }

  function anadirProductoAlCarrito(boton) {
    if (!boton || boton.disabled || boton.dataset.cargando === 'true') {
      return;
    }

    var datosProducto = obtenerDatosProductoDesdeBoton(boton);

    if (!datosProducto.variantId) {
      boton.textContent = 'error';
      return;
    }

    var textoOriginal = boton.innerHTML;
    var formData = new FormData();

    formData.append('id', datosProducto.variantId);
    formData.append('quantity', datosProducto.quantity);
    formData.append('sections', 'cart-drawer');
    formData.append('sections_url', window.location.pathname);

    boton.dataset.cargando = 'true';
    boton.disabled = true;
    boton.textContent = 'añadiendo...';

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then(function (respuesta) {
        if (!respuesta.ok) {
          return respuesta.json().then(function (error) {
            throw error;
          });
        }

        return respuesta.json();
      })
      .then(function (respuestaCarrito) {
        boton.textContent = 'añadido ✓';

        return refrescarDrawerCarrito(respuestaCarrito).catch(function () {
          return null;
        });
      })
      .then(function () {
        window.setTimeout(function () {
          boton.innerHTML = textoOriginal;
          boton.disabled = false;
          boton.dataset.cargando = 'false';
        }, 1300);
      })
      .catch(function () {
        boton.textContent = 'error';

        window.setTimeout(function () {
          boton.innerHTML = textoOriginal;
          boton.disabled = false;
          boton.dataset.cargando = 'false';
        }, 1300);
      });
  }

  document.addEventListener('click', function (evento) {
    if (evento.target.closest('cart-drawer')) {
      return;
    }

    var botonRestar = evento.target.closest('[data-coleccion-kylie-restar], [data-destacada-kylie-restar]');
    var botonSumar = evento.target.closest('[data-coleccion-kylie-sumar], [data-destacada-kylie-sumar]');

    if (botonRestar || botonSumar) {
      evento.preventDefault();
      evento.stopPropagation();

      var contenedor = evento.target.closest('[class*="__cantidad"]');

      if (!contenedor) {
        return;
      }

      var input = contenedor.querySelector('input[type="number"]');

      if (!input) {
        return;
      }

      var valor = parseInt(input.value, 10);

      if (Number.isNaN(valor) || valor < 1) {
        valor = 1;
      }

      if (botonSumar) {
        valor += 1;
      }

      if (botonRestar) {
        valor = Math.max(1, valor - 1);
      }

      input.value = valor;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    var botonAnadir = evento.target.closest('.coleccion-kylie__boton, .destacada-kylie__boton, [class*="coleccion-kylie-"][class*="__boton"], [class*="destacada-kylie"][class*="__boton"]');

    if (!botonAnadir) {
      return;
    }

    var formBoton = botonAnadir.closest('form');

    if (!formBoton || !formBoton.matches('form[action*="/cart/add"], form[action*="/cart/add.js"]')) {
      return;
    }

    evento.preventDefault();
    evento.stopPropagation();

    anadirProductoAlCarrito(botonAnadir);
  }, true);

  document.addEventListener('submit', function (evento) {
    if (evento.target.closest('cart-drawer')) {
      return;
    }

    var form = evento.target.closest('form[action*="/cart/add"], form[action*="/cart/add.js"]');

    if (!form || !form.matches('.destacada-kylie__boton-form')) {
      return;
    }

    var boton = form.querySelector('button[type="submit"], button');

    if (!boton) {
      return;
    }

    evento.preventDefault();
    evento.stopPropagation();

    anadirProductoAlCarrito(boton);
  }, true);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
class HeaderKylieFijo extends HTMLElement {
  constructor() {
    super();
    this.actualizarEstadoScroll = this.actualizarEstadoScroll.bind(this);
    this.actualizarAlturaHeader = this.actualizarAlturaHeader.bind(this);
    this.actualizarAnclaMega = this.actualizarAnclaMega.bind(this);
    this.activarHover = this.activarHover.bind(this);
    this.desactivarHover = this.desactivarHover.bind(this);
    this.abrirPanel = this.abrirPanel.bind(this);
    this.cerrarPanel = this.cerrarPanel.bind(this);
    this.controlarEscape = this.controlarEscape.bind(this);
    this.prepararCarrito = this.prepararCarrito.bind(this);
    this.actualizarIconoCarrito = this.actualizarIconoCarrito.bind(this);
    this.actualizarAltoPanelMovil = this.actualizarAltoPanelMovil.bind(this);
  }

  connectedCallback() {
    this.header = this.querySelector('.cabecera-kylie-principal');
    this.botonMenu = this.querySelector('.cabecera-kylie-menu-movil-boton');
    this.panel = this.querySelector('.cabecera-kylie-panel-movil');
    this.overlay = this.querySelector('.cabecera-kylie-overlay');
    this.botonCerrar = this.querySelector('.cabecera-kylie-panel-movil-cerrar');
    this.tabs = this.querySelectorAll('.cabecera-kylie-panel-tab');
    this.contenidosTabs = this.querySelectorAll('.cabecera-kylie-panel-contenido-tab');
    this.desplegables = this.querySelectorAll('.cabecera-kylie-desplegable');
    this.esTransparenteInicial = this.dataset.transparenteInicial === 'true';

    this.actualizarAlturaHeader();
    this.actualizarEstadoScroll();
    this.actualizarIconoCarrito();
    this.actualizarAltoPanelMovil();

    window.addEventListener('scroll', this.actualizarEstadoScroll, { passive: true });
    window.addEventListener('resize', this.actualizarAlturaHeader);
    window.addEventListener('resize', this.actualizarAltoPanelMovil);
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', this.actualizarAltoPanelMovil);
    }
    document.addEventListener('keydown', this.controlarEscape);
    document.addEventListener('cart:updated', this.actualizarIconoCarrito);
    document.addEventListener('cart:refresh', this.actualizarIconoCarrito);

    if (this.header && this.esTransparenteInicial) {
      this.header.addEventListener('mouseenter', this.activarHover);
      this.header.addEventListener('mouseleave', this.desactivarHover);
    }

    if (this.botonMenu) {
      this.botonMenu.addEventListener('click', this.abrirPanel);
    }

    if (this.botonCerrar) {
      this.botonCerrar.addEventListener('click', this.cerrarPanel);
    }

    if (this.overlay) {
      this.overlay.addEventListener('click', this.cerrarPanel);
    }

    this.querySelectorAll('.cabecera-kylie-icono--carrito').forEach((enlaceCarrito) => {
      enlaceCarrito.addEventListener('click', this.prepararCarrito);
    });

    this.tabs.forEach((tab) => {
      if (tab.tagName.toLowerCase() === 'a') {
        return;
      }

      tab.addEventListener('click', () => {
        const indice = tab.dataset.tabIndex;

        this.tabs.forEach((boton) => boton.classList.remove('cabecera-kylie-panel-tab--activo'));
        this.contenidosTabs.forEach((contenido) => contenido.classList.remove('cabecera-kylie-panel-contenido-tab--activo'));

        tab.classList.add('cabecera-kylie-panel-tab--activo');

        const contenidoActivo = this.querySelector(`[data-contenido-index="${indice}"]`);

        if (contenidoActivo) {
          contenidoActivo.classList.add('cabecera-kylie-panel-contenido-tab--activo');
          contenidoActivo.scrollTop = 0;
        }

        tab.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center'
        });
      });
    });

    this.desplegables.forEach((desplegable) => {
      desplegable.addEventListener('mouseenter', () => {
        if (window.matchMedia('(min-width: 990px)').matches) {
          this.actualizarAnclaMega();
          this.desplegables.forEach((otro) => {
            if (otro !== desplegable) {
              otro.removeAttribute('open');
            }
          });
          desplegable.setAttribute('open', '');
        }
      });

      desplegable.addEventListener('mouseleave', () => {
        if (window.matchMedia('(min-width: 990px)').matches) {
          desplegable.removeAttribute('open');
        }
      });

      desplegable.addEventListener('focusin', () => {
        if (window.matchMedia('(min-width: 990px)').matches) {
          this.actualizarAnclaMega();
        }
      });
    });
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.actualizarEstadoScroll);
    window.removeEventListener('resize', this.actualizarAlturaHeader);
    window.removeEventListener('resize', this.actualizarAltoPanelMovil);
    if (window.visualViewport) {
      window.visualViewport.removeEventListener('resize', this.actualizarAltoPanelMovil);
    }
    document.removeEventListener('keydown', this.controlarEscape);
    document.removeEventListener('cart:updated', this.actualizarIconoCarrito);
    document.removeEventListener('cart:refresh', this.actualizarIconoCarrito);

    this.querySelectorAll('.cabecera-kylie-icono--carrito').forEach((enlaceCarrito) => {
      enlaceCarrito.removeEventListener('click', this.prepararCarrito);
    });

    if (this.header) {
      this.header.removeEventListener('mouseenter', this.activarHover);
      this.header.removeEventListener('mouseleave', this.desactivarHover);
    }
  }

  actualizarIconoCarrito() {
    fetch('/cart.js', {
      method: 'GET',
      headers: {
        Accept: 'application/json'
      }
    })
      .then((respuesta) => respuesta.json())
      .then((carrito) => {
        const enlaceCarrito = this.querySelector('#cart-icon-bubble');

        if (!enlaceCarrito) {
          return;
        }

        const cantidad = carrito.item_count || 0;
        let contenedorIcono = enlaceCarrito.querySelector('.cabecera-kylie-icono-carrito-svg');

        if (!contenedorIcono) {
          contenedorIcono = document.createElement('span');
          contenedorIcono.className = 'cabecera-kylie-icono-carrito-svg';
          contenedorIcono.innerHTML = `
            <svg class="cabecera-kylie-svg cabecera-kylie-svg--carrito" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
              <path d="M6.8 8.2H17.2L16.4 21H7.6L6.8 8.2Z"></path>
              <path d="M9.2 8.2C9.2 5.8 10.3 4 12 4C13.7 4 14.8 5.8 14.8 8.2"></path>
            </svg>
          `;

          enlaceCarrito.innerHTML = '';
          enlaceCarrito.appendChild(contenedorIcono);
        }

        let burbuja = enlaceCarrito.querySelector('.cabecera-kylie-burbuja-carrito');

        if (cantidad > 0) {
          if (!burbuja) {
            burbuja = document.createElement('span');
            burbuja.className = 'cabecera-kylie-burbuja-carrito';
            burbuja.setAttribute('aria-hidden', 'true');
            enlaceCarrito.appendChild(burbuja);
          }

          burbuja.textContent = cantidad < 100 ? cantidad : '99+';
        } else if (burbuja) {
          burbuja.remove();
        }
      })
      .catch(() => {});
  }

  prepararCarrito() {
    document.documentElement.classList.add('cabecera-kylie-carrito-abierto');

    document.querySelectorAll('#CartDrawer-Overlay, .cart-drawer__overlay, .drawer__overlay, .cart-notification__overlay').forEach((overlayCarrito) => {
      overlayCarrito.style.opacity = '';
      overlayCarrito.style.visibility = '';
      overlayCarrito.style.pointerEvents = '';
      overlayCarrito.style.display = '';
    });

    window.clearTimeout(this.temporizadorPreparandoCarrito);
    this.temporizadorPreparandoCarrito = window.setTimeout(() => {
      document.documentElement.classList.remove('cabecera-kylie-carrito-abierto');
    }, 1400);
  }

  activarHover() {
    if (this.esTransparenteInicial && !this.classList.contains('cabecera-kylie-scroll-activo')) {
      this.classList.add('cabecera-kylie-hover-activo');
    }
  }

  desactivarHover() {
    this.classList.remove('cabecera-kylie-hover-activo');
  }

  abrirPanel() {
    if (!this.panel) {
      return;
    }

    this.actualizarAltoPanelMovil();

    const contenidoActivoInicial = this.querySelector('.cabecera-kylie-panel-contenido-tab--activo');
    if (contenidoActivoInicial) {
      contenidoActivoInicial.scrollTop = 0;
    }

    if (this.contenidosTabs.length && !this.querySelector('.cabecera-kylie-panel-contenido-tab--activo')) {
      this.contenidosTabs[0].classList.add('cabecera-kylie-panel-contenido-tab--activo');
      if (this.tabs.length) {
        this.tabs[0].classList.add('cabecera-kylie-panel-tab--activo');
      }
    }

    this.panel.classList.add('cabecera-kylie-panel-movil--abierto');
    this.panel.setAttribute('aria-hidden', 'false');

    if (this.overlay) {
      this.overlay.classList.add('cabecera-kylie-overlay--visible');
      this.overlay.setAttribute('aria-hidden', 'false');
    }

    if (this.botonMenu) {
      this.botonMenu.setAttribute('aria-expanded', 'true');
    }

    document.body.classList.add('cabecera-kylie-menu-abierto');
    document.body.style.overflow = 'hidden';
  }

  cerrarPanel() {
    if (!this.panel) {
      return;
    }

    this.panel.classList.remove('cabecera-kylie-panel-movil--abierto');
    this.panel.setAttribute('aria-hidden', 'true');

    if (this.overlay) {
      this.overlay.classList.remove('cabecera-kylie-overlay--visible');
      this.overlay.setAttribute('aria-hidden', 'true');
    }

    if (this.botonMenu) {
      this.botonMenu.setAttribute('aria-expanded', 'false');
    }

    document.body.classList.remove('cabecera-kylie-menu-abierto');
    document.body.style.overflow = '';
  }

  controlarEscape(evento) {
    if (evento.key === 'Escape') {
      this.cerrarPanel();
      this.desplegables.forEach((desplegable) => desplegable.removeAttribute('open'));
    }
  }

  actualizarAltoPanelMovil() {
    const altoVisible = window.visualViewport
      ? window.visualViewport.height
      : window.innerHeight;

    if (altoVisible > 0) {
      this.style.setProperty(
        '--cabecera-kylie-alto-panel-movil',
        `${Math.round(altoVisible)}px`
      );
    }
  }

  actualizarAlturaHeader() {
    if (!this.header) {
      return;
    }

    const alturaHeader = this.header.offsetHeight;
    document.documentElement.style.setProperty('--header-height', `${alturaHeader}px`);
    this.actualizarAnclaMega();
  }

  actualizarAnclaMega() {
    if (!this.header) {
      return;
    }

    const borde = this.header.getBoundingClientRect().bottom;
    const anclaMega = Math.max(borde, 0);
    document.documentElement.style.setProperty('--cabecera-kylie-ancla-mega', `${anclaMega}px`);
  }

  actualizarEstadoScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    this.actualizarAnclaMega();

    if (!this.esTransparenteInicial) {
      this.classList.add('cabecera-kylie-scroll-activo');
      return;
    }

    if (scrollTop > 4) {
      this.classList.add('cabecera-kylie-scroll-activo');
      this.classList.remove('cabecera-kylie-hover-activo');
    } else {
      this.classList.remove('cabecera-kylie-scroll-activo');
    }
  }
}

if (!customElements.get('header-kylie-fijo')) {
  customElements.define('header-kylie-fijo', HeaderKylieFijo);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  (function () {
    function obtenerRootShopify() {
      if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
        return window.Shopify.routes.root;
      }

      return '/';
    }

    function obtenerCarritoVisual() {
      return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    }

    function abrirCarritoVisual() {
      var carritoVisual = obtenerCarritoVisual();

      if (carritoVisual && typeof carritoVisual.open === 'function') {
        carritoVisual.open();
        return;
      }

      var botonCarrito = document.querySelector('#cart-icon-bubble') || document.querySelector('.header__icon--cart') || document.querySelector('a[href="/cart"]');

      if (botonCarrito) {
        botonCarrito.click();
      }
    }

    function reemplazarDrawerCarrito(htmlDrawer) {
      if (!htmlDrawer) {
        return false;
      }

      var documento = new DOMParser().parseFromString(htmlDrawer, 'text/html');
      var nuevoDrawer = documento.querySelector('cart-drawer');
      var drawerActual = document.querySelector('cart-drawer');

      if (!nuevoDrawer || !drawerActual) {
        return false;
      }

      drawerActual.outerHTML = nuevoDrawer.outerHTML;

      return true;
    }

    function refrescarDrawerCarrito(respuestaCarrito) {
      if (respuestaCarrito && respuestaCarrito.sections && respuestaCarrito.sections['cart-drawer']) {
        var reemplazadoDesdeRespuesta = reemplazarDrawerCarrito(respuestaCarrito.sections['cart-drawer']);

        if (reemplazadoDesdeRespuesta) {
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: respuestaCarrito }));
          document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: respuestaCarrito }));

          window.requestAnimationFrame(function () {
            abrirCarritoVisual();
          });

          return Promise.resolve();
        }
      }

      return fetch(obtenerRootShopify() + '?sections=cart-drawer', {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
        .then(function (respuesta) {
          return respuesta.json();
        })
        .then(function (secciones) {
          reemplazarDrawerCarrito(secciones['cart-drawer']);

          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: respuestaCarrito }));
          document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: respuestaCarrito }));

          window.requestAnimationFrame(function () {
            abrirCarritoVisual();
          });
        });
    }

    function obtenerDatosProductoDesdeBoton(boton) {
      var tarjeta = boton.closest('article') || boton.closest('[class*="__tarjeta"]') || boton.closest('li');
      var form = boton.closest('form');

      if (!form && tarjeta) {
        form = tarjeta.querySelector('form[action*="/cart/add"]') || tarjeta.querySelector('form[action*="/cart/add.js"]') || tarjeta.querySelector('form');
      }

      var inputId = form ? form.querySelector('input[name="id"]') : null;

      if (!inputId && tarjeta) {
        inputId = tarjeta.querySelector('input[name="id"]');
      }

      var inputCantidad = tarjeta ? tarjeta.querySelector('input[name="quantity"]') : null;

      var variantId = inputId ? inputId.value : '';
      var quantity = inputCantidad ? parseInt(inputCantidad.value, 10) : 1;

      if (Number.isNaN(quantity) || quantity < 1) {
        quantity = 1;
      }

      return {
        variantId: variantId,
        quantity: quantity
      };
    }

    function anadirProductoAlCarrito(boton) {
      if (!boton || boton.disabled || boton.dataset.cargando === 'true') {
        return;
      }

      var datosProducto = obtenerDatosProductoDesdeBoton(boton);

      if (!datosProducto.variantId) {
        boton.textContent = 'error';
        return;
      }

      var textoOriginal = boton.innerHTML;
      var formData = new FormData();

      formData.append('id', datosProducto.variantId);
      formData.append('quantity', datosProducto.quantity);
      formData.append('sections', 'cart-drawer');
      formData.append('sections_url', window.location.pathname);

      boton.dataset.cargando = 'true';
      boton.disabled = true;
      boton.textContent = 'añadiendo...';

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
        .then(function (respuesta) {
          if (!respuesta.ok) {
            return respuesta.json().then(function (error) {
              throw error;
            });
          }

          return respuesta.json();
        })
        .then(function (respuestaCarrito) {
          return refrescarDrawerCarrito(respuestaCarrito);
        })
        .then(function () {
          boton.textContent = 'añadido ✓';

          window.setTimeout(function () {
            boton.innerHTML = textoOriginal;
            boton.disabled = false;
            boton.dataset.cargando = 'false';
          }, 1300);
        })
        .catch(function () {
          boton.textContent = 'error';

          window.setTimeout(function () {
            boton.innerHTML = textoOriginal;
            boton.disabled = false;
            boton.dataset.cargando = 'false';
          }, 1300);
        });
    }

    document.addEventListener('click', function (evento) {
      var botonRestar = evento.target.closest('[data-coleccion-kylie-restar]');
      var botonSumar = evento.target.closest('[data-coleccion-kylie-sumar]');

      if (botonRestar || botonSumar) {
        evento.preventDefault();
        evento.stopPropagation();

        var contenedor = evento.target.closest('[class*="__cantidad"]');

        if (!contenedor) {
          return;
        }

        var input = contenedor.querySelector('input[type="number"]');

        if (!input) {
          return;
        }

        var valor = parseInt(input.value, 10);

        if (Number.isNaN(valor) || valor < 1) {
          valor = 1;
        }

        if (botonSumar) {
          valor += 1;
        }

        if (botonRestar) {
          valor = Math.max(1, valor - 1);
        }

        input.value = valor;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }

      var botonAnadir = evento.target.closest('[class*="coleccion-kylie-"][class*="__boton"]');

      if (!botonAnadir) {
        return;
      }

      var formBoton = botonAnadir.closest('form');

      if (!formBoton || !formBoton.matches('form[action*="/cart/add"], form[action*="/cart/add.js"]')) {
        return;
      }

      evento.preventDefault();
      evento.stopPropagation();

      anadirProductoAlCarrito(botonAnadir);
    }, true);

    document.addEventListener('submit', function (evento) {
      var form = evento.target.closest('form[action*="/cart/add"], form[action*="/cart/add.js"]');

      if (!form || !form.matches('[class*="coleccion-kylie-"][class*="__boton-form"]')) {
        return;
      }

      var boton = form.querySelector('button[type="submit"], button');

      if (!boton) {
        return;
      }

      evento.preventDefault();
      evento.stopPropagation();

      anadirProductoAlCarrito(boton);
    }, true);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (() => {
    const limpiarTexto = (texto) => texto.replace(/\s+/g, ' ').trim();

    const obtenerTextoBaseBoton = (span) => {
      const texto = limpiarTexto(span.textContent).toLowerCase();

      if (texto.includes('agotado')) return 'Agotado';
      if (texto.includes('sold out')) return 'Sold out';
      if (texto.includes('add to cart')) return 'add to cart';

      return 'Agregar al carrito';
    };

    const obtenerPreciosProducto = (lineaCompra) => {
      const contenedorProducto = lineaCompra.closest('.product__info-container') || document;
      const bloquePrecio = contenedorProducto.querySelector('.price');

      if (!bloquePrecio) return null;

      const precioActualOfertaElemento =
        bloquePrecio.querySelector('.price__sale .price-item--sale') ||
        bloquePrecio.querySelector('.price-item--sale');

      const precioAnteriorElemento =
        bloquePrecio.querySelector('.price__sale .price-item--regular') ||
        bloquePrecio.querySelector('.price-item--regular s') ||
        bloquePrecio.querySelector('s.price-item') ||
        bloquePrecio.querySelector('s');

      if (precioActualOfertaElemento && precioAnteriorElemento) {
        const precioActual = limpiarTexto(precioActualOfertaElemento.textContent);
        const precioAnterior = limpiarTexto(precioAnteriorElemento.textContent);

        if (precioActual && precioAnterior && precioActual !== precioAnterior) {
          return {
            tieneDescuento: true,
            actual: precioActual,
            anterior: precioAnterior
          };
        }
      }

      const precioNormalElemento =
        bloquePrecio.querySelector('.price__regular .price-item--regular') ||
        bloquePrecio.querySelector('.price-item--regular') ||
        bloquePrecio.querySelector('.price-item');

      if (!precioNormalElemento) return null;

      const precioNormal = limpiarTexto(precioNormalElemento.textContent);

      if (!precioNormal) return null;

      return {
        tieneDescuento: false,
        actual: precioNormal,
        anterior: null
      };
    };

    const actualizarPreciosBotonCompra = () => {
      document.querySelectorAll('.producto-linea-compra').forEach((lineaCompra) => {
        const span = lineaCompra.querySelector('.product-form__submit > span');

        if (!span) return;

        if (!span.dataset.textoOriginalBoton || span.dataset.textoOriginalBoton === 'añadir' || span.dataset.textoOriginalBoton === 'añadir carrito') {
          span.dataset.textoOriginalBoton = obtenerTextoBaseBoton(span);
        }

        const precios = obtenerPreciosProducto(lineaCompra);

        if (!precios) {
          span.textContent = span.dataset.textoOriginalBoton;
          return;
        }

        const esMovil = window.matchMedia('(max-width: 520px)').matches;
        const textoOriginal = span.dataset.textoOriginalBoton;
        const textoBase = textoOriginal.toLowerCase().includes('agotado')
          ? textoOriginal
          : esMovil
            ? 'añadir carrito'
            : textoOriginal;

        if (precios.tieneDescuento) {
          span.innerHTML = `${textoBase} - <span class="boton-precio-actual">${precios.actual}</span> <span class="boton-precio-anterior">${precios.anterior}</span>`;
        } else {
          span.innerHTML = `${textoBase} - <span class="boton-precio-normal">${precios.actual}</span>`;
        }
      });
    };

    actualizarPreciosBotonCompra();

    document.addEventListener('DOMContentLoaded', () => {
      setTimeout(actualizarPreciosBotonCompra, 150);
    });

    document.addEventListener('variant:change', () => {
      setTimeout(actualizarPreciosBotonCompra, 150);
    });

    document.addEventListener('shopify:section:load', () => {
      setTimeout(actualizarPreciosBotonCompra, 150);
    });

    document.addEventListener('change', (evento) => {
      if (
        evento.target.closest('.product-form__input') ||
        evento.target.closest('variant-selects') ||
        evento.target.closest('variant-radios')
      ) {
        setTimeout(actualizarPreciosBotonCompra, 200);
      }
    });

    window.addEventListener('resize', () => {
      clearTimeout(window.productoPrecioBotonResize);
      window.productoPrecioBotonResize = setTimeout(actualizarPreciosBotonCompra, 150);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
